import React from "react";
import { ScrollView, StyleSheet } from "react-native";
import Animated, { Easing, ReduceMotion, useAnimatedStyle, withTiming, } from "react-native-reanimated";
export const CollapsibleDrawer = ({ isOpen, maxHeight, children, style, contentStyle, hideScrollIndicators = false, ...props }) => {
    const animatedStyle = useAnimatedStyle(() => {
        return {
            maxHeight: isOpen
                ? withTiming(maxHeight ?? 320, {
                    duration: 300,
                    easing: Easing.out(Easing.ease),
                    reduceMotion: ReduceMotion.System,
                })
                : withTiming(0, {
                    duration: 300,
                    easing: Easing.out(Easing.ease),
                    reduceMotion: ReduceMotion.System,
                }),
        };
    });
    return (<Animated.View {...props} style={[styles.container, animatedStyle, style]}>
      <ScrollView style={[styles.scrollContainer, contentStyle]} {...(hideScrollIndicators
        ? {
            showsVerticalScrollIndicator: false,
            showsHorizontalScrollIndicator: false,
        }
        : {})}>
        {children}
      </ScrollView>
    </Animated.View>);
};
const styles = StyleSheet.create({
    container: {
        overflow: "hidden",
    },
    scrollContainer: {
        paddingHorizontal: 32,
        paddingVertical: 8,
        marginBottom: 8,
        maxHeight: 250,
    },
});
//# sourceMappingURL=CollapsibleDrawer.js.map